import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.73 9.708c0 .505.118.984.327 1.409a3.64 3.64 0 0 0-.767 2.068 5.03 5.03 0 0 1-1.393-3.476A5.05 5.05 0 0 1 13 4.776c1.908.393 3.455 1.93 3.862 3.836.123.575.146 1.14.083 1.678a.913.913 0 0 1-.914.794h-.041c-.543 0-.924-.483-.864-1.022a3.196 3.196 0 0 0-2.434-3.474 3.215 3.215 0 0 0-3.964 3.12zM5.164 8.521a6.8 6.8 0 0 1 2.073-3.83c1.402-1.313 3.237-1.962 5.16-1.843 3.624.234 6.458 3.409 6.415 7.21-.017 1.59-1.35 2.857-2.94 2.857h-2.206a1.828 1.828 0 0 0-3.584.515c0 1.013.82 1.833 1.834 1.833.493 0 .94-.197 1.268-.514h2.688c2.584 0 4.737-2.058 4.774-4.641.068-4.786-3.527-8.792-8.13-9.089a8.63 8.63 0 0 0-6.532 2.336 8.74 8.74 0 0 0-2.617 4.827.917.917 0 0 0 .906 1.069c.433 0 .819-.302.891-.73m6.774 8.062c-3.387 0-6.317 2.1-7.291 5.227a.917.917 0 0 0 .602 1.148.92.92 0 0 0 1.147-.602c.724-2.32 3.002-3.94 5.542-3.94s4.818 1.62 5.54 3.94a.917.917 0 0 0 1.752-.546c-.975-3.126-3.905-5.227-7.292-5.227"
    }, null, -1)
  ]))]))
}
export default { render: render }